export const GUEST_SESSION_HEADER = 'X-Guest-Session';

/** The link token the guest arrived with, kept so an expired session can send them back to re-verify. */
export const GUEST_LINK_TOKEN_KEY = 'workflowGuestLinkToken';

const STORAGE_KEY = 'workflowGuestSession';

export interface StoredGuestSession {
  token: string;
  workflowItemId: number;
  expiresAt?: string | null;
  email?: string | null;
}

/**
 * The guest's credential lives in sessionStorage, not localStorage: closing the tab ends the
 * session, and it never leaks into another tab's signed-in context.
 */
export function storeGuestSession(session: StoredGuestSession): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function readGuestSession(): StoredGuestSession | null {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as StoredGuestSession;
    if (!parsed?.token) return null;
    if (parsed.expiresAt && new Date(parsed.expiresAt).getTime() <= Date.now()) {
      clearGuestSession();
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function getGuestSessionToken(): string | null {
  return readGuestSession()?.token ?? null;
}

export function clearGuestSession(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
